import { ThemeProvider } from "styled-components";
import {
  AppendixContainer,
  AppendixTitle,
  ColouredSectionText,
  DesignCriq2BadHeader,
  DesignCriq2BigContainer,
  DesignCriq2Container,
  DesignCriq2Content,
  DesignCriq2GoodHeader,
  DesignCriqBody,
  DesignCriqContainer,
  DesignCriqHeader,
  DesignCriqHeaderTitle,
  DesignCriqImage,
  DesignCriqList,
  DesignCriqListItem,
  DesignCriqSubbody,
  DesignCriqSubbodyTitle,
  DesignCriqTable,
  DesignCriqTitle,
  FigmaContainer,
  FigmaTitle,
  FooterContainer,
  HeroContainer,
  HeroSubtitle,
  HeroSubtitleBelow,
  HeroTitle,
  IntervieweeContainer,
  IntervieweeInfo,
  IntervieweeName,
  IntervieweePicture,
  IntervieweesContainer,
  JobstobedoneArrowContainer,
  JobstobedoneContainer,
  JobstobedoneHeader,
  JobstobedoneSubContainer,
  JobstobedoneSubContainerTitle,
  PageContainer,
  ProposedSolutionContainer,
  ProposedSolutionPicture,
  ProposedSolutionPicture2,
  ProposedSolutionSubtitle,
  ProposedSolutionText,
  ProposedSolutionTitle,
  Reference,
  ReferencesContainer,
  SectionContainer,
  SectionContent,
  SectionSubHeader,
  SectionSubtitle,
  SectionText,
  SectionTitle,
  TypewriterContainer,
  UserJourneyContainer,
  UserJourneyTitle,
  UserJourneyVideo,
  UserJourneyVideoSubtitle,
  UserPersonaBottomContainer,
  UserPersonaBottomContainerTitle,
  UserPersonaBottomSubContainer,
  UserPersonaContainer,
  UserPersonaTopContainer,
  VerticalLine,
} from "./PageStyles";
import React, { useRef, useState } from "react";
import { darkTheme, theme } from "../theme";
import Navbar from "../components/Navbar";
import Typewriter from "typewriter-effect";
import SlidingTransition from "../components/Sliding/SlidingTransition";
import { GiJourney } from "react-icons/gi";
import betweenStations from "../assets/videos/between-stations.mp4";
import trainArriving from "../assets/videos/train-arriving.mp4";
import trainStopped from "../assets/videos/train-stopped.mp4";
import doorsClosing from "../assets/videos/doors-closing.mp4";
import { GoArrowUpRight } from "react-icons/go";
import joel from "../assets/pictures/joel.jpg";
import ziqi from "../assets/pictures/ziqi.jpg";
import ryan from "../assets/pictures/ryan.jpg";
import darryl from "../assets/pictures/darryl.jpg";
import nadia from "../assets/pictures/nadia.jpg";
import { FaArrowRightLong } from "react-icons/fa6";
import betweenStationsImg from "../assets/pictures/between-stations-pics.png";
import arriving1 from "../assets/pictures/arriving1.png";
import arriving2 from "../assets/pictures/arriving2.png";
import arriving3 from "../assets/pictures/arriving3.png";
import doorsopen from "../assets/pictures/doorsopen.png";
import doorclosing1 from "../assets/pictures/closing1.png";
import doorclosing2 from "../assets/pictures/closing2.png";
import betweenStationsShort from "../assets/videos/between-stations-short.mp4";
import betweenStationsHD from "../assets/pictures/betweenstationshd.jpg";
import betweenStationsRightWBox from "../assets/pictures/betweenstationsrightwbox.png";
import betweenstationssol1 from "../assets/pictures/betweenstationssol1.png";
import greenlineref from "../assets/pictures/greenlineref.png";
import doorsopensol1 from "../assets/pictures/doorsopensol1.png";
import taiwanref1 from "../assets/pictures/taiwanref1.png";
import doorsclosingnew1 from "../assets/pictures/doorsclosingnew1.png";
import doorsclosingref from "../assets/pictures/doorsclosingref.png";
import doorsclosingidea1 from "../assets/videos/doorsclosingidea1.mp4";
import doorsclosingidea1pic from "../assets/pictures/doorclosingnew/doorsclosingcomplied.png";
import doorsclosingideacompiled from "../assets/pictures/doorsclosingsolcomplied.png";

const HomePage = () => {
  const [darkMode, setDarkMode] = useState(true);
  const toggleDarkMode = () => {
    console.log("clicked");
    setDarkMode(!darkMode);
  };

  const pageTopRef = useRef(null);
  const introductionRef = useRef(null);
  const userjourneyRef = useRef(null);
  const targetUserRef = useRef(null);
  const appendixRef = useRef(null);
  const designCritique = useRef(null);
  const designCritique2 = useRef(null);
  const solutionRef = useRef(null);
  const conclusionRef = useRef(null);
  const navbarItems = [
    { title: "Start", ref: pageTopRef },
    { title: "Introduction", ref: introductionRef },
    {
      title: "Problems To Solve",
      ref: userjourneyRef,
    },
    { title: "Target User", ref: targetUserRef },
    {
      title: "Design Critique I",
      ref: designCritique,
    },
    {
      title: "Design Critique II",
      ref: designCritique2,
    },
    { title: "Proposed Solution", ref: solutionRef },
    { title: "Conclusion", ref: conclusionRef },
    { title: "Appendix", ref: appendixRef },
  ];

  const references = [
    "https://www.statista.com/topics/5880/passenger-transport-in-singapore/#statisticChapter",
    "https://www.techinasia.com/talk/smrt-new-display-ux-problem",
    "https://github.com/jglim/IdentityFont",
    "https://jitter.video/",
  ];

  const FoodNamesArray = ["", "", "", "", "", "", "", "", ""];
  const [shutterMode, setShutterMode] = useState("side");

  const departingLeftBadContent = [
    {
      header: "Misuse of Contrast",
      content:
        "The background is black and the station name uses a bright red, which is difficult to see. The text 'Next Station' is in white which draws the users' eyes there first instead of the station name, which is the more important information. The station number 'EW26' is wrapped in a bright green box too. ",
      content2:
        "These bright elements agasint the black background confuses the eye on where to look and the information the display tries to convey is not clear. Colourblind people also might not be able to see the station name if the contrast is too low.",
    },
    {
      header: "Unclear Typopgraphy",
      content:
        "The font size for the station name can be much bigger, both for accessbility purposes and also to make it easier for people to get that information easier. A bigger font size would also help to make the station name more prominent, drawing attention to it to emphasise it.",
      content2:
        "Typography is also inconsistent with the LTA identity font used in the rest of the MRT system, making it inconsistent.",
    },
    {
      header: "Not Aesthetic",
      content:
        "'Interfaces should not contain information that is irrelevant or rarely needed'. That is one of the Usability Heuristics. The reflective graphic of the station names and circle draws necessary attention and makes the information harder to see. It does not add any asthetic value either. ",
      content2:
        "The fading in and fading out animation of all the elements on the screen is also not necessary and makes it more difficult for users to get the information they want. If users look up at the wrong, they have to wait for the lengthy animation to complete before they can see what station is next or where they are.  ",
    },
    {
      header: "Others",
      content: "The theme overall is very outdated.",
    },
  ];

  const departingRightBadContent = [
    {
      header: "Mismatch Between Design And Real Life",
      content:
        "In real life, pasir ris is on the right side of singapore while tuas link is on the left. The green line represented on the standard MRT map reflects this and users have gotten used to seeing the green line in this way.",
      content2:
        "However, this design does not follow Jakob's Law, increasing the cognitive effort needed to understand the map, making the information unclear. To make things worse, this map only flashes briefly as the train leaves the station, switching to ads after 5-10 seconds. This is not enough time for users to understand the map.",
    },
    {
      header: "Cramped Elements, Lack Of Negative Space",
      content:
        "It is understandale that the screen is small and to fit a whole map inside that space is challenging. However, the text showing the direction of the train is squeezed in together with the map, making it difficult to see and it feels very suffocating. ",
    },
    {
      header: "Miuse Of Similarity",
      content:
        "'Train ends at' and 'Transfer to' are both in bright yellow. Firstly, these elements are stealing attention from other more important elements like the stations' names. Secondly, both elements in yellow gives the idea they are related in same way, but they are not, which adds additional subtle confusion to the user.",
    },
  ];

  const arrivingContent = [
    {
      header: "Bad Use Of Emphasis",
      content:
        "The use of the green colour to indicate the station name is not bad however they also use the blue colour to highlight some part of the staton which I am also not sure what it is supposed to represent. This distracts from the elements that actually need emphasis like the station name and exits. ",
    },
    {
      header: "Too Many Elements",
      content:
        "There are too many shapes and lines used in these designs and there is no clear visual hierocracy for the elements. There is not enough time for the user to see  all the information and to understand it, adding on the confusing visual hierarchy, all the user will see is a complicated graphic. It is difficult for users to convert 2D drawings to 3D space too. ",
    },
    {
      header: "Other Comments",
      content:
        "I think I understand that they were trying to fit as much information as possible into the screen to make sure of the digital display. However it can definitely be designed better with a clearer layout and visual hierarchy. ",
    },
  ];

  const doorsopenContent = [
    {
      header: "Bad Typography",
      content:
        "The background is has a texture and the text has too little font weight and the font size is abit too small. This combination results in reduced readability of the station name, especially for people with poorer eyesight or are further away. ",
      content2:
        "It would be better to use a thicker font weight and increase the font size. The background is actually the MRT map with a blurred texture laid on top. This is completely unnecessary as it is not noticable enough and only serves to clutter the design. ",
    },
    {
      header: "Emphasis On The Wrong Element",
      content:
        "The station number wrapped in the green box has a high contrast agasint the semi white background. This creates a visual hierachy where the user looks at the station number first before the name, creating emphasis on the wrong element. The font size and weight of the station number is also too high, which draws attention to it.",
    },
    {
      header: "Poor Visibility Of System Status",
      content:
        "'The design should always keep users informed about what is going on, through appropriate feedback within a reasonable amount of time'. This screen also has a fade in and fade out animation which lasts several seconds. In terms of user hecristics, this is a bad user interface as it does not show the station name consistently or reliably. ",
    },
  ];

  const doorsclosingContent1 = [
    {
      header: "Inconsistent Typography",
      content:
        "In the previous screens that we have seen, the type used was something similar to an Arial font, whereas this is comic sans or something similar to that. Even though both are sans serif fonts, comic sans has more prominent curves and this creates inconsistency in the design. ",
    },
    {
      header: "Uneven Alignement",
      content:
        "The 'Doors Closing' is not even aligned to the center of the screen.",
    },
    {
      header: "Other Comments",
      content:
        "The comic sans ruins the whole design theme because it looks so childish and out of place. I conceed that despite how ugly the screen is, it does fulfil its purpose, it does fulfil users' needs to tell them the door is closing. I think this screen is a very lazy design and done up with little to no thought and this creates a bad asethetic. ",
    },
  ];

  const doorsclosingContent2 = [
    {
      header: "Lack of balance",
      content:
        "The left side of the screen shows a door that uses gradient and has a 3D feel to it, whereas the right screen has flat colours. This throws the whole graphic off balance and makes it seems abit weird due to the inconsistent design styles. ",
      content2:
        "The left side is trying to emulate a real life experience of a door closing even showing the graphic of a real MRT door while the right side is just showing a 2D flat ugly cross icon. It is not cohesive.",
    },
    {
      header: "Unnecessary Elements",
      content:
        "There is no need for the reflection of the door. I am glad the design is consistent with the other screens. Consistently ugly and outdated. ",
    },
  ];
  return (
    <ThemeProvider theme={darkMode ? darkTheme : theme}>
      <Navbar
        darkMode={darkMode}
        navbarItems={navbarItems}
        toggleDarkMode={toggleDarkMode}
      />
      <PageContainer>
        {/* <SlidingTransition
          shutterMode={shutterMode}
          inputArray={FoodNamesArray}
        /> */}
        <HeroContainer ref={pageTopRef}>
          <HeroSubtitle>Design Analysis of</HeroSubtitle>
          <HeroTitle>MRT Door Screens</HeroTitle>
          <HeroSubtitleBelow>
            A Final Design Project by Marcel
          </HeroSubtitleBelow>
        </HeroContainer>
        <SectionContainer ref={introductionRef}>
          <SectionTitle>Introduction</SectionTitle>
          <SectionContent>
            <SectionText>
              In 2022, an average of approximately 2.7 million passengers a day
              used the Mass Rapid Transit (MRT) in Singapore. Safe to say there
              are alot of people riding the MRT everyday and they range from
              young children to the elderly.
            </SectionText>
            <SectionText>
              We will look at one of the designs in the MRT: The screen above
              the doors inside the MRT. Specifically, we will look at the design
              from the{" "}
              <ColouredSectionText color={theme.green}>
                East-West Line.
              </ColouredSectionText>
            </SectionText>
            <SectionText>
              For this project,{" "}
              <ColouredSectionText color={theme.smrtSecondary}>
                5 people
              </ColouredSectionText>{" "}
              were interviewed on their User journey and their general thoughts
              on the design. We will look at their User Persona and the data
              collected will be used throughout this project.
            </SectionText>
          </SectionContent>
        </SectionContainer>

        <SectionContainer ref={userjourneyRef}>
          <SectionTitle>
            Intended Problems To Solve
            {/* <GiJourney /> */}
          </SectionTitle>
          <SectionSubtitle>
            An overview of the screen designs during the user journey
          </SectionSubtitle>
          <SectionContent>
            <SectionText>
              Background: The original analog design needed to be replaced as
              Singapore as a growing nation, has constant construction and
              upgrades of new stations. Thus everytime there is a new station,
              the old physical display needs to be replaced. Hence they needed
              to create a digital display containing all the same information
              and more information which only a digital display can provide.
            </SectionText>
            <SectionText>
              The main problems to solve are{" "}
              <ColouredSectionText color={theme.smrtSecondary}>
                providing relevant information
              </ColouredSectionText>{" "}
              to travellers at different stages during the journey{" "}
              <ColouredSectionText color={theme.smrtSecondary}>
                easily and accessable
              </ColouredSectionText>{" "}
              at any point in time or wherever they are in the train. So that
              users will have{" "}
              <ColouredSectionText color={theme.smrtSecondary}>
                ease of mind
              </ColouredSectionText>{" "}
              ease of mind of where they are and they{" "}
              <ColouredSectionText color={theme.smrtSecondary}>
                won't miss their stop
              </ColouredSectionText>
              .{" "}
            </SectionText>
            <SectionText>
              Let's take a look at the user journey (ft. me):
            </SectionText>
            <UserJourneyContainer>
              <UserJourneyTitle>
                1. User gets on train, train starts to depart
              </UserJourneyTitle>
              <UserJourneyVideo
                src={betweenStations}
                autoPlay={true}
                type="video/mp4"
                preload="auto"
                muted={true}
                loop={true}
              />
              <UserJourneyVideoSubtitle>
                The screen will play from departure and in between stations
              </UserJourneyVideoSubtitle>
              <SectionText>
                <b>Problems intended to solve:</b> Inform the user where they
                are heading towards, the station they just left and more
                upcoming stations. At the same time try to sell products to
                users since they are already looking at the screen.
              </SectionText>
            </UserJourneyContainer>
            <UserJourneyContainer>
              <UserJourneyTitle>
                2. Train arriving into station
              </UserJourneyTitle>
              <UserJourneyVideo
                src={trainArriving}
                autoPlay={true}
                type="video/mp4"
                preload="auto"
                muted={true}
                loop={true}
              />
              <UserJourneyVideoSubtitle>
                This screen starts to play as the train slows down until before
                the doors open
              </UserJourneyVideoSubtitle>
              <SectionText>
                <b>Problems intended to solve:</b> Give users information on the
                station to make their commute easier and help them to{" "}
                <ColouredSectionText color={theme.smrtSecondary}>
                  save time
                </ColouredSectionText>
                . The goal was also to help users who are new to the station
                quickly famaliarise themselves with the station and its exits.
              </SectionText>
            </UserJourneyContainer>
            <UserJourneyContainer>
              <UserJourneyTitle>3. Train doors open</UserJourneyTitle>
              <UserJourneyVideo
                src={trainStopped}
                autoPlay={true}
                type="video/mp4"
                preload="auto"
                muted={true}
                loop={true}
              />
              <UserJourneyVideoSubtitle>
                This screen flashes on and off until the just before the doors
                close
              </UserJourneyVideoSubtitle>
              <SectionText>
                <b>Problems intended to solve:</b> Inform users on the train
                what station they are at and if they are not getting off, then
                allow them to see how many more stops they have remaining.
              </SectionText>
            </UserJourneyContainer>
            <UserJourneyContainer>
              <UserJourneyTitle>4. Train doors closing</UserJourneyTitle>
              <UserJourneyVideo
                src={doorsClosing}
                autoPlay={true}
                type="video/mp4"
                preload="auto"
                muted={true}
                loop={true}
              />
              <UserJourneyVideoSubtitle>
                This screen appears as the doors are closing until the train
                starts to depart
              </UserJourneyVideoSubtitle>
              <SectionText>
                <b>Problems intended to solve:</b> Warn users that the doors are
                closing and providing a countdown so people dont rush out of the
                train and get injured or killed.
              </SectionText>
            </UserJourneyContainer>
            <UserJourneyContainer>
              <UserJourneyTitle>
                5. Train departs, cycle repeats
              </UserJourneyTitle>
              <UserJourneyVideo
                src={betweenStations}
                autoPlay={true}
                type="video/mp4"
                preload="auto"
                muted={true}
                loop={true}
              />
              <UserJourneyVideoSubtitle>
                This screen appears right after the doors close and will last
                till the train is about to arrive at the next station
              </UserJourneyVideoSubtitle>
              <SectionText>
                <b>Problems intended to solve:</b> Users would look up as the
                train is moving to see the next station and this screen tries to
                provide that information to them and upcoming stations. It also
                flashes the map to help users see how many more stops they have
                left to their destination.
              </SectionText>
            </UserJourneyContainer>

            <SectionText>
              These screens and their designs will the focus of this project and
              will be victim of critique in the later sections. We will now
              explore the problems that SMRT tried to solve with these screens'
              designs
            </SectionText>
            <VerticalLine />
          </SectionContent>
        </SectionContainer>
        <SectionContainer ref={targetUserRef}>
          <SectionTitle>Target User</SectionTitle>
          <SectionSubtitle>
            Who are we aiming to help? What are their needs?
          </SectionSubtitle>
          <SectionContent>
            <SectionText>
              {" "}
              For this project, we will focus on 1 target user. Specifically,{" "}
              <ColouredSectionText color={theme.smrtSecondary}>
                university students aged from 21 to 24 years old
              </ColouredSectionText>{" "}
              (based on user interviews). A user persona will be created and
              then we can explore Jobs To Be Done and How Might We to better
              understand their pain points and needs.
            </SectionText>
          </SectionContent>{" "}
          <SectionContent>
            <SectionSubHeader>Meet Our Interviewees</SectionSubHeader>
            <SectionText style={{ width: "80%" }}>
              <IntervieweesContainer>
                <IntervieweeContainer>
                  <IntervieweePicture src={nadia} />
                  <IntervieweeName>Nadia</IntervieweeName>
                  <IntervieweeInfo>
                    21 y/o <br />
                    University Student <br />
                    Home, School,
                    <br /> Yoga <br />
                  </IntervieweeInfo>
                </IntervieweeContainer>
                <IntervieweeContainer>
                  <IntervieweePicture src={darryl} />
                  <IntervieweeName>Darryl</IntervieweeName>
                  <IntervieweeInfo>
                    24 y/o <br />
                    University Student <br />
                    Home, School,
                    <br /> Shopping <br />
                  </IntervieweeInfo>
                </IntervieweeContainer>
                <IntervieweeContainer>
                  <IntervieweePicture src={ryan} />
                  <IntervieweeName>Ryan</IntervieweeName>
                  <IntervieweeInfo>
                    22 y/o <br />
                    University Student <br />
                    Home, School,
                    <br /> Wildlife Photog <br />
                  </IntervieweeInfo>
                </IntervieweeContainer>
                <IntervieweeContainer>
                  <IntervieweePicture src={ziqi} />
                  <IntervieweeName>Ziqi</IntervieweeName>
                  <IntervieweeInfo>
                    22 y/o <br />
                    University Student <br />
                    Home, School,
                    <br /> Meet Friends <br />
                  </IntervieweeInfo>
                </IntervieweeContainer>
                <IntervieweeContainer>
                  <IntervieweePicture src={joel} />
                  <IntervieweeName>Joel</IntervieweeName>
                  <IntervieweeInfo>
                    24 y/o <br />
                    University Student <br />
                    Home, School,
                    <br /> Social <br />
                  </IntervieweeInfo>
                </IntervieweeContainer>
              </IntervieweesContainer>
              <TypewriterContainer>
                <Typewriter
                  options={{
                    strings: [
                      "'More stations, I wanna to see the map and what station I am at'",
                      "'I do use it but the way its formatted is weird'",
                      "'Not completely reliable'",
                      "'You know exactly where to go to'",
                      "'The design is confusing for the exits and exit fare gates'",
                      "'Countdown is useless, I want to know the next station'",
                      "'The image showing the next stations has too small labels'",
                      "'I want to see how long from one station to another station'",
                      "'Quite ass'",
                    ],
                    autoStart: true,
                    loop: true,
                    delay: 30,
                    deleteSpeed: 15,
                  }}
                />
              </TypewriterContainer>
            </SectionText>
          </SectionContent>
          <SectionContent>
            <SectionSubHeader>User Persona</SectionSubHeader>
            <SectionText>
              A user persona is template based on the behaviours and mindsets
              from research. It is important as it helps to build empathy for
              the end user and develops clarity for the design. Based on the
              interviewees, we can create a user persona that looks something
              like:
            </SectionText>
            <UserPersonaContainer>
              <UserPersonaTopContainer>
                21 - 24 year old university students, who are going to class
                early in the morning in a packed train and going home late at
                night in an empty train. They take the train on most weekdays.
                On exam days they also need to know if they will be on time.
                Weekends they go meet their friends or go out with family
              </UserPersonaTopContainer>
              <UserPersonaBottomContainer>
                <UserPersonaBottomSubContainer>
                  <UserPersonaBottomContainerTitle>
                    Goals
                  </UserPersonaBottomContainerTitle>
                  Get to school or the place where they hanging out with their
                  friends.
                  <br />
                  <br /> Be on time / know if they are running late
                </UserPersonaBottomSubContainer>
                <UserPersonaBottomSubContainer>
                  <UserPersonaBottomContainerTitle>
                    Pain Points
                  </UserPersonaBottomContainerTitle>
                  Rather use phone for checking the full map as map on train is
                  not easily accessable
                  <br />
                  <br /> Wants to know where they are
                </UserPersonaBottomSubContainer>
                <UserPersonaBottomSubContainer>
                  <UserPersonaBottomContainerTitle>
                    Behaviour
                  </UserPersonaBottomContainerTitle>
                  Checks the screen once or twice per journey, especially when
                  the train is arriving at the station or departing the station
                  <br />
                  <br /> Uses their phone most of the time
                </UserPersonaBottomSubContainer>
              </UserPersonaBottomContainer>
            </UserPersonaContainer>
          </SectionContent>
          <SectionContent>
            <SectionSubHeader>Jobs To Be Done & How Might We</SectionSubHeader>

            <JobstobedoneContainer>
              <JobstobedoneSubContainer>
                <JobstobedoneHeader>
                  Situation When I / He / She...
                </JobstobedoneHeader>
                <JobstobedoneSubContainerTitle>
                  Describe as much as possible the context where the job to be
                  done has to be executed.
                </JobstobedoneSubContainerTitle>
                Taking the MRT, travelling from one place to another, most
                likely from school to home from home to school (main use)
              </JobstobedoneSubContainer>
              <JobstobedoneArrowContainer>
                <FaArrowRightLong />
              </JobstobedoneArrowContainer>

              <JobstobedoneSubContainer>
                <JobstobedoneHeader>Motivation I want to...</JobstobedoneHeader>
                <JobstobedoneSubContainerTitle>
                  What are the most central tasks that must be accomplished in
                  getting the job done?
                </JobstobedoneSubContainerTitle>
                Information on where the user is and how many more stops
                remaining / how much time left
                <br />
                <br />
                Readily available information at any point during the journey
              </JobstobedoneSubContainer>
              <JobstobedoneArrowContainer>
                <FaArrowRightLong />
              </JobstobedoneArrowContainer>
              <JobstobedoneSubContainer>
                <JobstobedoneHeader>
                  Goal/Expected Outcome So I can...
                </JobstobedoneHeader>
                <JobstobedoneSubContainerTitle>
                  Understand why your customer do this
                </JobstobedoneSubContainerTitle>
                So they can be on time for class / knows if they is going to be
                late/{" "}
                <ColouredSectionText color={theme.smrtSecondary}>
                  ease of mind
                </ColouredSectionText>
                , knows when to get off,{" "}
                <ColouredSectionText color={theme.smrtSecondary}>
                  doesnt miss their stop
                </ColouredSectionText>
                . <br />
                <br />
                Convenience, less frustration, dont have to move around just to
                find that information
              </JobstobedoneSubContainer>
            </JobstobedoneContainer>
          </SectionContent>
          <SectionContent>
            <SectionSubHeader>User needs</SectionSubHeader>
            <SectionText>
              Knowing where they are <br /> Knowing what is the next station{" "}
              <br /> How long more to their destination
              <br />
              <br /> Wont miss stop <br /> Know long more to destination for
              ease of mind
            </SectionText>
            <SectionText>
              Now that we have the condensed user needs, we can critique the
              design. We will see if the design fulfils the user's needs first
              then take another purely based on Elements & Principles of Design
              & Usability Heuristics & Gestalt Principles of Design
            </SectionText>
          </SectionContent>
        </SectionContainer>

        <SectionContainer ref={designCritique}>
          <SectionTitle>Design Critique I</SectionTitle>
          <SectionSubtitle>Based On User Needs</SectionSubtitle>
          <SectionContent>
            <SectionText>
              Based on the user interviews conducted, this section will present
              each stage of the user journey along with the design and the user
              needs based on the stage. Then we will look at the design to see
              if it has fulfilled the user needs or not. These user needs are
              based on the interviews conducted.
            </SectionText>
            <DesignCriqContainer>
              <DesignCriqTitle>Departing / Between Stations</DesignCriqTitle>
              <DesignCriqImage src={betweenStationsImg} />
              <DesignCriqTable>
                <DesignCriqHeader>
                  <DesignCriqHeaderTitle>User Needs</DesignCriqHeaderTitle>
                  Next station <br /> The departing station <br /> Number of
                  stations to destination / A map of the line or a full map of
                  the system
                  <br /> Direction of train <br /> Duration of ride from one
                  station to another
                </DesignCriqHeader>
                <DesignCriqBody>
                  <DesignCriqSubbody style={{ color: theme.green }}>
                    <DesignCriqSubbodyTitle>Fulfilled</DesignCriqSubbodyTitle>
                    <DesignCriqList>
                      <DesignCriqListItem>
                        Next station is shown
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Departing station is shown
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Able to see how many more stations to destination
                      </DesignCriqListItem>
                    </DesignCriqList>
                  </DesignCriqSubbody>
                  <DesignCriqSubbody style={{ color: theme.red }}>
                    <DesignCriqSubbodyTitle>
                      Not Fulfilled
                    </DesignCriqSubbodyTitle>

                    <DesignCriqList>
                      <DesignCriqListItem>
                        How many stops more to user destination
                      </DesignCriqListItem>

                      <DesignCriqListItem>
                        More stations in the left screen
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Too small to see anything from far
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Not reliable because the other half is when it's showing
                        ads
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Duration to next station
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Direction of train not clear
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Too short duration to count stations, flashes quickly
                        before ads come
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Previous 1 or 2 stations before in case missed stop
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Map doesn't show where you are now
                      </DesignCriqListItem>
                    </DesignCriqList>
                  </DesignCriqSubbody>
                </DesignCriqBody>
              </DesignCriqTable>
            </DesignCriqContainer>
            <DesignCriqContainer>
              <DesignCriqTitle>Arriving At Station</DesignCriqTitle>
              <DesignCriqImage src={arriving1} />
              <DesignCriqImage src={arriving2} />
              <DesignCriqImage src={arriving3} />
              <DesignCriqTable>
                <DesignCriqHeader>
                  <DesignCriqHeaderTitle>User Needs</DesignCriqHeaderTitle>
                  Station name that the train is arriving at <br />
                  The next few stations so the user can prepare to get off
                  <br /> Exits information (which exit goes to which mall){" "}
                  <br />
                </DesignCriqHeader>
                <DesignCriqBody>
                  <DesignCriqSubbody style={{ color: theme.green }}>
                    <DesignCriqSubbodyTitle>Fulfilled</DesignCriqSubbodyTitle>
                    <DesignCriqList>
                      <DesignCriqListItem>
                        Exit information is shown and user can save time
                      </DesignCriqListItem>
                    </DesignCriqList>
                  </DesignCriqSubbody>
                  <DesignCriqSubbody style={{ color: theme.red }}>
                    <DesignCriqSubbodyTitle>
                      Not Fulfilled
                    </DesignCriqSubbodyTitle>

                    <DesignCriqList>
                      <DesignCriqListItem>
                        Does not show how many more stops to destination
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Major bus interchange in that station
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Screen / Information flashes so quickly that you cant
                        see what's going on
                      </DesignCriqListItem>
                    </DesignCriqList>
                  </DesignCriqSubbody>
                </DesignCriqBody>
              </DesignCriqTable>
            </DesignCriqContainer>
            <DesignCriqContainer>
              <DesignCriqTitle>Doors Open At Station</DesignCriqTitle>
              <DesignCriqImage src={doorsopen} />

              <DesignCriqTable>
                <DesignCriqHeader>
                  <DesignCriqHeaderTitle>User Needs</DesignCriqHeaderTitle>
                  Current station, so that they don't miss their stop <br />
                  Duration / Number of stops to their destination
                  <br /> Timer for how long more before the doors close starting
                  when doors open
                  <br />
                </DesignCriqHeader>
                <DesignCriqBody>
                  <DesignCriqSubbody style={{ color: theme.green }}>
                    <DesignCriqSubbodyTitle>Fulfilled</DesignCriqSubbodyTitle>
                    <DesignCriqList>
                      <DesignCriqListItem>
                        Current station is shown clearly
                      </DesignCriqListItem>
                      <DesignCriqListItem>
                        Users are able to count the number of stops to their
                        destination
                      </DesignCriqListItem>
                    </DesignCriqList>
                  </DesignCriqSubbody>
                  <DesignCriqSubbody style={{ color: theme.red }}>
                    <DesignCriqSubbodyTitle>
                      Not Fulfilled
                    </DesignCriqSubbodyTitle>

                    <DesignCriqList>
                      <DesignCriqListItem>
                        Timer for how long more the doors will stay open
                      </DesignCriqListItem>
                    </DesignCriqList>
                  </DesignCriqSubbody>
                </DesignCriqBody>
              </DesignCriqTable>
            </DesignCriqContainer>
            <DesignCriqContainer>
              <DesignCriqTitle>Doors Closing At Station</DesignCriqTitle>
              <DesignCriqImage src={doorclosing1} />
              <DesignCriqImage src={doorclosing2} />
              <DesignCriqTable>
                <DesignCriqHeader>
                  <DesignCriqHeaderTitle>User Needs</DesignCriqHeaderTitle>
                  Time to next station <br />
                  Door closing to warn people
                  <br />
                  Dont need this screen because can tell that the doors are
                  closing, it will be too late to exit the train at this point
                  <br />
                </DesignCriqHeader>
                <DesignCriqBody>
                  <DesignCriqSubbody style={{ color: theme.green }}>
                    <DesignCriqSubbodyTitle>Fulfilled</DesignCriqSubbodyTitle>
                    <DesignCriqList>
                      <DesignCriqListItem>
                        Shows doors are closing
                      </DesignCriqListItem>
                    </DesignCriqList>
                  </DesignCriqSubbody>
                  <DesignCriqSubbody style={{ color: theme.red }}>
                    <DesignCriqSubbodyTitle>
                      Not Fulfilled
                    </DesignCriqSubbodyTitle>

                    <DesignCriqList>
                      <DesignCriqListItem>
                        Countdown not useful at all for people inside the train
                      </DesignCriqListItem>
                    </DesignCriqList>
                  </DesignCriqSubbody>
                </DesignCriqBody>
              </DesignCriqTable>
            </DesignCriqContainer>
            <SectionText>
              Overall, the screens do somewhat fulfil the user needs, however
              there is definitely room for improvement to cater to our user
              persona's needs more.
            </SectionText>
          </SectionContent>
        </SectionContainer>

        <SectionContainer ref={designCritique2}>
          <SectionTitle>Design Critique II</SectionTitle>
          <SectionSubtitle>
            Based On Design Principals and others{" "}
          </SectionSubtitle>
          <SectionContent>
            <SectionText>
              In this section, we will take a look at the graphic in the screens
              and critique them based on these rules: Elements & Principles of
              Design, Usability Heuristics and Gestalt Principles of Design.
            </SectionText>
            <SectionText>
              Usability Heuristics: For this particular critique, I have decided
              to only use these rules, since this screen is non-interactable:
              <DesignCriqList>
                <DesignCriqListItem>
                  Visibility of system status
                </DesignCriqListItem>
                <DesignCriqListItem>
                  Match between system and the real world
                </DesignCriqListItem>
                <DesignCriqListItem>
                  Consistency and standards
                </DesignCriqListItem>
                <DesignCriqListItem>
                  Aesthetic and minimalist design
                </DesignCriqListItem>
              </DesignCriqList>
            </SectionText>
            <DesignCriqContainer>
              <DesignCriqTitle>
                Departing / Between Stations Left Screen
              </DesignCriqTitle>
              <UserJourneyVideo
                src={betweenStationsShort}
                autoPlay={true}
                type="video/mp4"
                preload="auto"
                muted={true}
                loop={true}
              />
              <DesignCriqImage src={betweenStationsHD} />
              <DesignCriq2BigContainer>
                <DesignCriq2Container>
                  <DesignCriq2GoodHeader>
                    Follows Gestalt's Law Of Continuation And Uses Movement
                  </DesignCriq2GoodHeader>
                  <DesignCriq2Content>
                    The red bar animates and moves towards the left and this
                    helps to guides the user's eyes towards that direction,
                    helping to them easily see the next station and the stations
                    after that
                  </DesignCriq2Content>
                </DesignCriq2Container>
                {departingLeftBadContent.map((content) => (
                  <DesignCriq2Container>
                    <DesignCriq2BadHeader>
                      {content.header}
                    </DesignCriq2BadHeader>
                    <DesignCriq2Content>
                      {content.content}
                      <br />
                      <br />
                      {content.content2}
                    </DesignCriq2Content>
                  </DesignCriq2Container>
                ))}
              </DesignCriq2BigContainer>
            </DesignCriqContainer>

            <DesignCriqContainer>
              <DesignCriqTitle>
                Departing / Between Stations Right Screen
              </DesignCriqTitle>

              <DesignCriqImage src={betweenStationsRightWBox} />
              <DesignCriq2BigContainer>
                <DesignCriq2Container>
                  <DesignCriq2GoodHeader>
                    Follows Gestalt's Law of Continuation
                  </DesignCriq2GoodHeader>
                  <DesignCriq2Content>
                    The use of lines to create a flow and helps to guide the
                    user's eye towards the next or previous station. It is also
                    a good attempt at fitting the map in the small screen while
                    keeping readability as high as possible.
                  </DesignCriq2Content>
                </DesignCriq2Container>
                {departingRightBadContent.map((content) => (
                  <DesignCriq2Container>
                    <DesignCriq2BadHeader>
                      {content.header}
                    </DesignCriq2BadHeader>
                    <DesignCriq2Content>
                      {content.content}
                      <br />
                      <br />
                      {content.content2}
                    </DesignCriq2Content>
                  </DesignCriq2Container>
                ))}
              </DesignCriq2BigContainer>
            </DesignCriqContainer>

            <DesignCriqContainer>
              <DesignCriqTitle>Arriving </DesignCriqTitle>

              <DesignCriqImage src={arriving1} />
              <DesignCriqImage src={arriving2} />
              <DesignCriqImage src={arriving3} />
              <DesignCriq2BigContainer>
                {arrivingContent.map((content) => (
                  <DesignCriq2Container>
                    <DesignCriq2BadHeader>
                      {content.header}
                    </DesignCriq2BadHeader>
                    <DesignCriq2Content>
                      {content.content}
                      <br />
                      <br />
                      {content.content2}
                    </DesignCriq2Content>
                  </DesignCriq2Container>
                ))}
              </DesignCriq2BigContainer>
            </DesignCriqContainer>

            <DesignCriqContainer>
              <DesignCriqTitle>Doors Open Screen</DesignCriqTitle>

              <UserJourneyVideo
                src={trainStopped}
                autoPlay={true}
                type="video/mp4"
                preload="auto"
                muted={true}
                loop={true}
              />
              <DesignCriqImage src={doorsopen} />
              <DesignCriq2BigContainer>
                <DesignCriq2Container>
                  <DesignCriq2GoodHeader>
                    Good use of negative space
                  </DesignCriq2GoodHeader>
                  <DesignCriq2Content>
                    The use of negative space helps to give emphasis on the
                    elements that are important which is the station name and
                    line.
                  </DesignCriq2Content>
                </DesignCriq2Container>
                {doorsopenContent.map((content) => (
                  <DesignCriq2Container>
                    <DesignCriq2BadHeader>
                      {content.header}
                    </DesignCriq2BadHeader>
                    <DesignCriq2Content>
                      {content.content}
                      <br />
                      <br />
                      {content.content2}
                    </DesignCriq2Content>
                  </DesignCriq2Container>
                ))}
              </DesignCriq2BigContainer>
            </DesignCriqContainer>
            <SectionText
              style={{
                border: `1px solid ${theme.smrt}`,
                padding: "1.5rem",
                color: theme.smrt,
              }}
            >
              {" "}
              Warning: This next section has an extremely biased critique due to
              my personal hate for the comic sans font used and the overall bad
              design.{" "}
            </SectionText>

            <DesignCriqContainer>
              <DesignCriqTitle>Doors Closing Screen 1</DesignCriqTitle>

              <DesignCriqImage src={doorclosing1} />

              <DesignCriq2BigContainer>
                <DesignCriq2Container></DesignCriq2Container>
                {doorsclosingContent1.map((content) => (
                  <DesignCriq2Container>
                    <DesignCriq2BadHeader>
                      {content.header}
                    </DesignCriq2BadHeader>
                    <DesignCriq2Content>
                      {content.content}
                      <br />
                      <br />
                      {content.content2}
                    </DesignCriq2Content>
                  </DesignCriq2Container>
                ))}
              </DesignCriq2BigContainer>
            </DesignCriqContainer>

            <DesignCriqContainer>
              <DesignCriqTitle>Doors Closing Screen 2</DesignCriqTitle>

              <DesignCriqImage src={doorclosing2} />
              <DesignCriq2BigContainer>
                {doorsclosingContent2.map((content) => (
                  <DesignCriq2Container>
                    <DesignCriq2BadHeader>
                      {content.header}
                    </DesignCriq2BadHeader>
                    <DesignCriq2Content>
                      {content.content}
                      <br />
                      <br />
                      {content.content2}
                    </DesignCriq2Content>
                  </DesignCriq2Container>
                ))}
              </DesignCriq2BigContainer>
            </DesignCriqContainer>
          </SectionContent>
        </SectionContainer>

        <SectionContainer ref={solutionRef}>
          <SectionTitle>Proposed Solution</SectionTitle>
          <SectionSubtitle>Time To Make It Beautiful</SectionSubtitle>
          <SectionContent>
            <SectionText>
              Keeping in mind our user persona's needs: <br />
              <br />
              <ColouredSectionText color={theme.smrtSecondary}>
                Knowing where they are <br /> Knowing what is the next station{" "}
                <br /> How long more to their destination
              </ColouredSectionText>
            </SectionText>
            <SectionText>
              Based on their needs and the design critique, we can propose a new
              design for each stage of the user journey. Assuming that the
              physical double screen cannot be changed, we will only be changing
              the design of what is shown on the screen. I also decided to use
              the LTA identity font to keep the design consistent with the rest
              of the LTA. Full list of references can be found in the appendix.
            </SectionText>
            {/* <SectionText>
              Only show what the user needs: Users need to get the information
              quickly at a glance and exactly what they need
            </SectionText> */}

            <ProposedSolutionContainer>
              <ProposedSolutionTitle>
                Departing / Between Stations Screen
              </ProposedSolutionTitle>
              <ProposedSolutionPicture src={betweenstationssol1} />

              <SectionText>
                <ProposedSolutionSubtitle>
                  Next Station Design (Left)
                </ProposedSolutionSubtitle>
                <DesignCriq2Content>
                  The left screen design is quite simple and minimalist. The
                  next station is what most users wanted so I made the font size
                  very big so it can be seen anywhere on the train. The use of
                  negative space also helps to focus the main information on the
                  screen. Even though the time and date are not user needs, I
                  felt that they helped to balance out the whole design and also
                  provide useful information.
                </DesignCriq2Content>
              </SectionText>
              <SectionText>
                <ProposedSolutionSubtitle>
                  Map Design (Right)
                </ProposedSolutionSubtitle>
                <DesignCriq2Content>
                  The map on the right was designed to emulate real life and the
                  current MRT map for the green line, which goes from left to
                  right and has a slight dip before going back up. I wanted to
                  reduce as much cognitive load on the user as possible and
                  design something that people were already familiar with so
                  they can find their stop faster (Jakob's Law). <br></br>There
                  was an attempt to emulate the analog screens with the glowing
                  dots to show the train's position to show where the user was.
                </DesignCriq2Content>
              </SectionText>
              <ProposedSolutionPicture2 src={greenlineref} />
              <UserJourneyVideoSubtitle>
                Reference: Isolated Green Line Map
              </UserJourneyVideoSubtitle>
              <SectionText></SectionText>

              <SectionText>
                <ProposedSolutionSubtitle>
                  Train Direction
                </ProposedSolutionSubtitle>
                <DesignCriq2Content>
                  Since I had alot of white space left over from the design, I
                  decided to put the direction of the train big and clear along
                  with the arrows with showed the physical direction in which
                  the train was moving. This allows users to quickly pick up the
                  direction they are going towards.
                </DesignCriq2Content>
              </SectionText>

              <SectionText>
                <ProposedSolutionSubtitle>
                  Disadvantages
                </ProposedSolutionSubtitle>
                <DesignCriq2Content>
                  One of the disadvantages with this design is that the map on
                  the right has station names which might be abit small and
                  cannot be seen from far away. This is the result of trying to
                  fit the map into this small screen while maintaining the
                  design that I was trying for. <br />
                  <br />
                  Another thing I noticed was that if the direction was removed,
                  there would be confusion for the lighted and non lighted dots.
                  Are the lighted dots upcoming stations or previous stations?
                  This is another flaw that could be fixed with more research.
                </DesignCriq2Content>
              </SectionText>
            </ProposedSolutionContainer>

            <ProposedSolutionContainer>
              <ProposedSolutionTitle>Doors Open Screen</ProposedSolutionTitle>
              <ProposedSolutionPicture src={doorsopensol1} />

              <SectionText>
                <ProposedSolutionSubtitle>
                  Current Station Design (Left)
                </ProposedSolutionSubtitle>
                <DesignCriq2Content>
                  The left screen embodies the same design principles as the
                  previous screen. Based on the user interviews, users would
                  usually look up to see what station they are at when the train
                  is slowly down / arriving at the station. Thus, the use of
                  negative space helps to focus the user's attention to the
                  center element which is the station name in a big font. <br />
                  <br />
                  The boxes containing the colour of the MRT line and the
                  station number has significant padding to show the colour of
                  the station more so users can quickly identify if they are at
                  the station or interchange they want to go. <br />
                  <br />
                  The "Arriving at" text is small as it is not the focus of the
                  design and just adds extra balance and complete information
                  for the user. The date and time on either side of the screen
                  balances out the design and provides useful information since
                  the user is already looking at the screen, they dont have to
                  look at their phones to check the time.
                  <br />
                  <br />
                  In combination, these elements allows users to obtain the
                  station name quickly and since there are no fading animations
                  or ads, the users can reliably get the information they need.
                </DesignCriq2Content>
              </SectionText>
              <SectionText>
                <ProposedSolutionSubtitle>
                  MRT Line Design (Right)
                </ProposedSolutionSubtitle>
                <DesignCriq2Content>
                  This screen was designed with user needs in mind: They wanted
                  to know the time to their next station and how many more stops
                  to their destination. This design shows the next station in a
                  bigger size at the bottom and it shows the time to the next
                  station. The number of minutes will count down in the actual
                  implementation. <br />
                  <br />
                  The right screen also features a line showing 4 stops ahead
                  and the previous stop. The time to the 4 stations are also
                  shown, this helps to inform the user the time left to their
                  destination as per the user needs identified. The previous
                  stop was included so users can check if they missed their
                  stop.
                  <br />
                  <br />
                  The arrow in the middle of the line points to the direction of
                  the train and at the end of the line there is the terminal
                  station name. Since knowing the direction of the train is not
                  an important need of our user persona, these elements are not
                  so prominent and are smaller in size.
                  <br />
                  <br />
                  Since this screen will be shown when the train is at the
                  station, the station it is currently at is in a bigger font
                  than the others so users can identify their position on the
                  line.
                </DesignCriq2Content>
              </SectionText>
              <ProposedSolutionPicture2 src={taiwanref1} />
              <UserJourneyVideoSubtitle>
                Reference: Taipei's MRT door screen
              </UserJourneyVideoSubtitle>
              <SectionText>
                <ProposedSolutionSubtitle>
                  Disadvantages
                </ProposedSolutionSubtitle>
                <DesignCriq2Content>
                  The MRT Line Design (Right) may appear squeezed when
                  implemented in the actual screen. There may be too many
                  elements in the design itself and that could cause confusion
                  to the elderly or even the user especially if they see the
                  screen for the first time. The learning curve for this design
                  is not as low as it can be. There could also be better
                  placements of elements and the overall design to give it a
                  more clean look.
                </DesignCriq2Content>
              </SectionText>
            </ProposedSolutionContainer>

            <ProposedSolutionContainer>
              <ProposedSolutionTitle>
                Doors Closing Screen
              </ProposedSolutionTitle>
              <ProposedSolutionPicture src={doorsclosingnew1} />
              <SectionText>
                <ProposedSolutionSubtitle>
                  Simple Design
                </ProposedSolutionSubtitle>
                <DesignCriq2Content>
                  Based on user interviews, users do not require any information
                  other than the information that the door is closing. A simple
                  design with an animation of the doors closing is able to serve
                  this purpose. This prevents people from dashing out of the
                  door at the last moment. Therefore the design of the screen is
                  using big fonts and big elements so people can see the
                  information presented from anywhere in the train.
                </DesignCriq2Content>
              </SectionText>
              <ProposedSolutionPicture2 src={doorsclosingref} />
              <UserJourneyVideoSubtitle>
                Reference: Thomson East Coast Line Door Screen
              </UserJourneyVideoSubtitle>{" "}
              <SectionText>
                <ProposedSolutionSubtitle>Other Ideas</ProposedSolutionSubtitle>
              </SectionText>
              <ProposedSolutionPicture2 src={doorsclosingidea1pic} />
              <UserJourneyVideo
                src={doorsclosingidea1}
                autoPlay={true}
                type="video/mp4"
                preload="auto"
                muted={true}
                loop={true}
              />
              <UserJourneyVideoSubtitle>
                Animation to emulate a door closing and transitioning to the
                screen for next station
              </UserJourneyVideoSubtitle>{" "}
              <ProposedSolutionPicture2
                style={{ marginTop: "5rem" }}
                src={doorsclosingideacompiled}
              />
            </ProposedSolutionContainer>
            <SectionText>
              <DesignCriq2Content>
                These are just some ideas I had based on the design principals
                learnt throughout the sememster and tailoring them to the user
                needs. There is no redesign for the exit information screen as
                users do not generally need that screen thus this redesign did
                not include it.
                <br />
                <br /> References and more ideas can be found in the appendix,
                in the figma design file.
              </DesignCriq2Content>
            </SectionText>
          </SectionContent>
        </SectionContainer>

        <SectionContainer ref={conclusionRef}>
          <SectionTitle>Conclusion</SectionTitle>
          <SectionSubtitle>Overall Thoughts & Reflections</SectionSubtitle>
          <SectionContent>
            <SectionText>
              <ProposedSolutionSubtitle>
                Other Personas
              </ProposedSolutionSubtitle>
              <DesignCriq2Content>
                The proposed solutions shown are designed purely on the user
                persona of a uni student and does not take into account other
                groups of people who have different needs. This is something to
                look into as the eldery have bad eyesight and it is important to
                include the station name all 4 languages. Designs that take
                these into account are needed and will be researched on more
                after this sememster is over.
              </DesignCriq2Content>
            </SectionText>
            <SectionText>
              <ProposedSolutionSubtitle>
                Hardest part of the project
              </ProposedSolutionSubtitle>
              <DesignCriq2Content>
                For me personally, designing a brand new interface or design is
                quite difficult because it is difficult for me to think out of
                the box or be creative as I think I am very rule-following.
                However, after understanding the user needs from the interviews,
                it was abit easier to design based on their needs. The lessons
                on good interface design and the revision on design principals
                also helped alot in this process. Overall this course has helped
                me to better understand the design process and gain a better
                appreciation for design (now I notice Norman doors everywhere).
              </DesignCriq2Content>
            </SectionText>

            <SectionText>
              <ProposedSolutionSubtitle>Things to do</ProposedSolutionSubtitle>
              <DesignCriq2Content>
                I think that I could have done more detailed and thoughtful
                designs and after this sem is over, I definitely will try to
                polish up this website and my ideas.{" "}
              </DesignCriq2Content>
            </SectionText>
          </SectionContent>
        </SectionContainer>

        <AppendixContainer ref={appendixRef}>
          <SectionTitle>Appendix</SectionTitle>

          <FigmaContainer>
            <FigmaTitle>Explore the Figma!</FigmaTitle>
            <iframe
              style={{
                border: `2px solid ${darkMode ? darkTheme.text : theme.text}`,
              }}
              width="80%"
              height="600"
              src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2F8GZG0fwKKPJePDv5XisUfo%2FIntro-to-Design-Final-Project%3Ftype%3Ddesign%26node-id%3D0%253A1%26mode%3Ddesign%26t%3DMoBNMuasvv3QXT4r-1"
              allowfullscreen
            ></iframe>
          </FigmaContainer>
          <ReferencesContainer>
            <FigmaTitle>References</FigmaTitle>
            {references.map((reference) => (
              <Reference target="_blank" href={reference}>
                {reference}
                <GoArrowUpRight />
              </Reference>
            ))}
          </ReferencesContainer>
        </AppendixContainer>
        <FooterContainer>
          <a style={{}} href="https://marcelyap.dev" target="_blank">
            marcelyap.dev
          </a>
          <br />
          19 Nov 2023
        </FooterContainer>
      </PageContainer>
    </ThemeProvider>
  );
};

export default HomePage;
